/*!

=========================================================
* Material Dashboard React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @material-ui/icons
import Home from "@material-ui/icons/Home";
import Map from "@material-ui/icons/Map";
import Person from "@material-ui/icons/Person";
import PersonPin from "@material-ui/icons/PersonPin";
import Group from "@material-ui/icons/Group";
import Print from "@material-ui/icons/Print";
import CloudDownload from "@material-ui/icons/CloudDownload";
import Timer from "@material-ui/icons/Timer";
import AccountBalance from "@material-ui/icons/AccountBalance";
import LocationCity from "@material-ui/icons/LocationCity";
import SearchOutlined from "@material-ui/icons/SearchOutlined";
import { Edit } from "@material-ui/icons";

import AdminDashboard from "views/AdminDashboard/AdminDashboard";
import OcsbDashboard from "views/AdminDashboard/OcsbDashboard";
import AssocDashboard from "views/AdminDashboard/AssocDashboard";
import Listuserlist from "views/UsersList/Listuserlist";

import Timereglist from "views/TimeReg/Timereglist";
import Factorylist from "views/Factory/Factorylist";
// import AssociationForAdmin from "views/AssociationForAdmin/Associationlist";
import AssociationTab from "views/Association/AssociationTab";
// import AssociationSummary from "views/Association/AssociationSummary";
import AssociationMembers from "views/Association/AssociationMember";
import Farmerlist from "views/Farmer/Farmerlist";
import ApproveTab from "views/ApproveRegister/ApproveTab";
// import ApproveListtemp from "views/ApproveRegister/ApproveListtemp";
// import ApproveMasterTemp from "views/ApproveRegister/ApproveMasterListtemp";
import ApproveMasterTab from "views/ApproveRegister/ApproveMasterTab";
import CheckStatusTab from "views/CheckStatus/CheckStatusTab";
import RegSugarForOcsbTab from "views/RegsugarcaneForOcsb/RegSugarForOcsbTab";
// import PrintPdf from "views/PrintPdf/PrintPdf";
// import PrintPdfMaster from "views/PrintPdf/PrintPdfMaster";
import PrintTab from "views/PrintPdf/PrintTab";
import CheckDeed from "views/CheckDeed/CheckDeed";
import DownloadPage from "views/DownloadPage/DownloadPage";
import RegsugarcaneTab from "views/RegsugarcaneTab/Regsugarcanetab";
import FarmerMasterTab from "views/RegsugarcaneTab/FarmerMasterTab";
// import ApproveData from "views/ApproveRegister/ApproveData";
// import ApproveMasterData from "views/ApproveRegister/ApproveMasterData";
import RegSugarRoundTab from "views/RegsugarcaneRound/RegSugarRoundTab";
import Contract from "views/Contract/ContractList";
import RegistrarDashboardTab from "views/Dashboard/RegistrarDashboardTab";
import StaffDashboardTab from "views/Dashboard/StaffDashboardTab";
import GIS from "views/Map/GIS";
import SentSugarcane from "views/Sugarcane/SentSugarcane";
import Search from "views/OcsbSearch/Search";
import SearchMaster from "views/OcsbSearch/SearchMaster";
import UploadSing from "views/UploadSign/UploadSing";

// import Login from "./components/login.component";

const RoutesAdmin = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: AdminDashboard,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "จัดการผู้ใช้งาน",
    rtlName: "Users",
    icon: Person,
    component: Listuserlist,
    layout: "/admin",
  },
  // {
  //   path: "/industry",
  //   name: "ข้อมูลโรงงาน",
  //   rtlName: "Industry",
  //   icon: LocationCity,
  //   component: Factorylist,
  //   layout: "/admin",
  // },
  // {
  //   path: "/institution",
  //   name: "ข้อมูลสมาคม",
  //   rtlName: "Association",
  //   icon: AccountBalance,
  //   component: AssociationForAdmin,
  //   layout: "/admin",
  // },
  {
    path: "/sign",
    name: "ลายเซนต์",
    rtlName: "UploadSing",
    icon: Edit,
    component: UploadSing,
    layout: "/admin",
  },
  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/admin",
  },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "FAQ",
  //   icon: LiveHelp,
  //   component: faqListtable,
  //   layout: "/admin",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/admin",
  // },
];

const RoutesStaff = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: StaffDashboardTab,
    layout: "/staff",
  },
  {
    path: "/farmer",
    name: "ข้อมูลพื้นฐานเกษตรกร",
    rtlName: "farmer",
    icon: Person,
    component: Farmerlist,
    layout: "/staff",
  },
  {
    path: "/regsugarcane",
    name: "จดทะเบียนชาวไร่อ้อย",
    rtlName: "regsugarcane",
    icon: Person,
    component: RegsugarcaneTab,
    layout: "/staff",
  },
  // {
  //   path: "/regsugarcane-data",
  //   name: "ข้อมูลชาวไร่อ้อย",
  //   rtlName: "regsugarcane-data",
  //   icon: Person,
  //   component: Regsugarcanedata,
  //   layout: "/staff",
  // },
  {
    path: "/registergroup",
    name: "หัวหน้ากลุ่มชาวไร่อ้อย",
    rtlName: "registergroup",
    icon: Group,
    component: FarmerMasterTab,
    layout: "/staff",
  },
  // {
  //   path: "/registergroup-data",
  //   name: "ข้อมูลหัวหน้ากลุ่มชาวไร่อ้อย",
  //   rtlName: "registergroup-data",
  //   icon: Group,
  //   component: Farmermasterdata,
  //   layout: "/staff",
  // },
  {
    path: "/printfarmer",
    name: "พิมพ์บัตร",
    rtlName: "Industry",
    icon: Print,
    component: PrintTab,
    layout: "/staff",
  },
  {
    path: "/checkdeed",
    name: "ตรวจสอบที่ดิน",
    rtlName: "Industry",
    icon: "content_paste",
    component: CheckDeed,
    layout: "/staff",
  },
  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/staff",
  },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "Question",
  //   icon: LiveHelp,
  //   component: Maps,
  //   layout: "/staff",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/staff",
  // },
];

const RoutesRegistrar = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: RegistrarDashboardTab,
    layout: "/registrar",
  },
  {
    path: "/timereg",
    name: "เพิ่มรอบจดทะเบียน",
    rtlName: "Timereg",
    icon: Timer,
    component: Timereglist,
    layout: "/registrar",
  },
  {
    path: "/approve",
    name: "จดทะเบียนชาวไร่อ้อย",
    rtlName: "Users",
    icon: Person,
    component: ApproveTab,
    layout: "/registrar",
  },
  {
    path: "/approve_master",
    name: "หัวหน้ากลุ่มชาวไร่อ้อย",
    rtlName: "Users",
    icon: Group,
    component: ApproveMasterTab,
    layout: "/registrar",
  },

  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/registrar",
  },
  // {
  //   path: "/approvetemp",
  //   name: "ชาวไร่อ้อยรอบ 2-65/66",
  //   rtlName: "Users",
  //   icon: Person,
  //   component: ApproveListtemp,
  //   layout: "/registrar",
  // },
  // {
  //   path: "/approve_master_temp",
  //   name: "หัวหน้ากลุ่มรอบ 2-65/66",
  //   rtlName: "Users",
  //   icon: Group,
  //   component: ApproveMasterTemp,
  //   layout: "/registrar",
  // },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "FAQ",
  //   icon: LiveHelp,
  //   component: Maps,
  //   layout: "/registrar",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/registrar",
  // },
];

const RoutesAssociation = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: AssocDashboard,
    layout: "/association",
  },
  // {
  //   path: "/masters",
  //   name: "หัวหน้ากลุ่ม",
  //   rtlName: "Assocition",
  //   icon: PersonPin,
  //   component: AssociationMasters,
  //   layout: "/association",
  // },
  {
    path: "/members",
    name: "สมาชิกสมาคม",
    rtlName: "Assocition",
    icon: PersonPin,
    component: AssociationMembers,
    layout: "/association",
  },
  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/association",
  },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "FAQ",
  //   icon: LiveHelp,
  //   component: Maps,
  //   layout: "/association",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/association",
  // },
];

const RoutesOCSB1 = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: OcsbDashboard,
    layout: "/ocsb",
  },
  {
    path: "/association",
    name: "สมาคม",
    rtlName: "Association",
    icon: AccountBalance,
    component: AssociationTab,
    layout: "/ocsb",
  },
  // {
  //   path: "/assocmembers",
  //   name: "สมาชิกสมาคม",
  //   rtlName: "Assocition",
  //   icon: PersonPin,
  //   component: AssociationMembers,
  //   layout: "/ocsb",
  // },
  {
    path: "/regsugarcane",
    name: "ข้อมูลการจดทะเบียน",
    rtlName: "registergroup",
    icon: Group,
    component: RegSugarRoundTab,
    layout: "/ocsb",
  },
  // {
  //   path: "/registergroup",
  //   name: "ข้อมูลการจดทะเบียน",
  //   rtlName: "Users",
  //   icon: Person,
  //   component: FormRegisterGroup,
  //   layout: "/ocsb",
  // },
  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/ocsb",
  },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "FAQ",
  //   icon: LiveHelp,
  //   component: Maps,
  //   layout: "/ocsb",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/ocsb",
  // },
];

const RoutesOCSB2 = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: OcsbDashboard,
    layout: "/ocsb",
  },
  {
    path: "/factory",
    name: "ข้อมูลโรงงาน",
    rtlName: "Industry",
    icon: LocationCity,
    component: Factorylist,
    layout: "/ocsb",
  },
  {
    path: "/association",
    name: "สมาคม",
    rtlName: "Association",
    icon: AccountBalance,
    component: AssociationTab,
    layout: "/ocsb",
  },
  // {
  //   path: "/assocmembers",
  //   name: "สมาชิกสมาคม",
  //   rtlName: "Assocition",
  //   icon: PersonPin,
  //   component: AssociationMembers,
  //   layout: "/ocsb",
  // },
  {
    path: "/editfarmer",
    name: "แก้ไขข้อมูลพื้นฐาน",
    rtlName: "Users",
    icon: Person,
    component: Farmerlist,
    layout: "/ocsb",
  },
  {
    path: "/regsugarcane",
    name: "แก้ไขสถานะชาวไร่อ้อย",
    rtlName: "Check data",
    icon: Person,
    component: RegSugarForOcsbTab,
    layout: "/ocsb",
  },
  {
    path: "/regsugarcanedata",
    name: "ข้อมูลการจดทะเบียน",
    rtlName: "regsugarcane data",
    icon: Group,
    component: RegSugarRoundTab,
    layout: "/ocsb",
  },
  {
    path: "/government",
    name: "ตรวจสอบข้อมูล",
    rtlName: "Check data",
    icon: "content_paste",
    component: CheckStatusTab,
    layout: "/ocsb",
  },
  {
    path: "/map",
    name: "แผนที่",
    rtlName: "Map",
    icon: Map,
    component: GIS,
    layout: "/ocsb",
  },

  // {
  //   path: "/printfarmer",
  //   name: "พิมพ์บัตร",
  //   rtlName: "Industry",
  //   icon: Print,
  //   component: PrintTab,
  //   layout: "/ocsb",
  // },
  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/ocsb",
  },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "FAQ",
  //   icon: LiveHelp,
  //   component: Maps,
  //   layout: "/ocsb",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/ocsb",
  // },
];

const RoutesIndustry = [
  {
    path: "/dashboard",
    name: "หน้าหลัก",
    rtlName: "Home",
    icon: Home,
    component: OcsbDashboard,
    layout: "/industry",
  },
  {
    path: "/association",
    name: "สมาคม",
    rtlName: "Association",
    icon: AccountBalance,
    component: AssociationTab,
    layout: "/industry",
  },
  {
    path: "/contract",
    name: "คู่สัญญา",
    rtlName: "contract",
    icon: PersonPin,
    component: Contract,
    layout: "/industry",
  },
  {
    path: "/sent-sugarcane",
    name: "ข้อมูลการผลิต",
    rtlName: "sent",
    icon: AccountBalance,
    component: SentSugarcane,
    layout: "/industry",
  },
  // {
  //   path: "/regsugarcane",
  //   name: "ข้อมูลการจดทะเบียน",
  //   rtlName: "registergroup",
  //   icon: Group,
  //   component: ApproveData,
  //   layout: "/industry",
  // },
  // {
  //   path: "/registergroup",
  //   name: "ข้อมูลการจดทะเบียน",
  //   rtlName: "Users",
  //   icon: Person,
  //   component: FormRegisterGroup,
  //   layout: "/ocsb",
  // },
  {
    path: "/download",
    name: "ดาวน์โหลด",
    rtlName: "Download",
    icon: CloudDownload,
    component: DownloadPage,
    layout: "/industry",
  },
  // {
  //   path: "/question",
  //   name: "คำถามที่พบบ่อย",
  //   rtlName: "FAQ",
  //   icon: LiveHelp,
  //   component: Maps,
  //   layout: "/ocsb",
  // },
  // {
  //   path: "/help",
  //   name: "คู่มือการใช้งาน",
  //   rtlName: "Manual",
  //   icon: LibraryBooks,
  //   component: NotificationsPage,
  //   layout: "/ocsb",
  // },
];
const RoutesOcsbSearch = [
  {
    path: "/search",
    name: "ค้นหาชาวไร่",
    rtlName: "Home",
    icon: SearchOutlined,
    component: Search,
    layout: "/ocsbsearch",
  },
  {
    path: "/search-master",
    name: "ค้นหา หน.กลุ่ม",
    rtlName: "Home",
    icon: SearchOutlined,
    component: SearchMaster,
    layout: "/ocsbsearch",
  },
];
let Route;
if (sessionStorage.getItem("user")) {
  const user = JSON.parse(sessionStorage.getItem("user"));

  if (user.user.member_type === 1) {
    Route = RoutesAdmin;
  } else if (user.user.member_type === 2) {
    Route = RoutesStaff;
  } else if (user.user.member_type === 3) {
    Route = RoutesRegistrar;
  } else if (user.user.member_type === 4) {
    Route = RoutesAssociation;
  } else if (user.user.member_type === 5) {
    Route = RoutesOCSB1;
  } else if (user.user.member_type === 6) {
    Route = RoutesOCSB2;
  } else if (user.user.member_type === 8) {
    Route = RoutesIndustry;
  } else if (user.user.member_type === 9) {
    Route = RoutesOcsbSearch;
  } else {
    Route = [];
  }
}
// console.log(dashboardRoutesStaff, dashboardRoutesRegistrar);

export default Route;
